module.exports = __webpack_public_path__ + "static/media/notebook.e9971a68.svg";